import React, {useState, useEffect} from 'react'

import {OnlineIcon} from './style'
import useSellerInfo from '../../actions/useSellerInfo'

export default () => {
    const {sellerInfo} = useSellerInfo('schedule')
    const [shouldAppear, setShouldAppear] = useState(sellerInfo === 'open')
    const dataTestLabel = 'icon_online'
    useEffect(() => {
        if(typeof sellerInfo !== 'string' || sellerInfo === 'no-info') {
            const now = new Date()
            const dayOfTheWeek = now.getDay()

            if(dayOfTheWeek !== 0) {
                const hours = now.getHours()

                if(dayOfTheWeek === 6)
                    setShouldAppear(hours >= 9 && hours <= 11)
                else
                    setShouldAppear(hours >= 9 && hours <= 17)
            }
        }
        else
            setShouldAppear(sellerInfo === 'open')
    }, [sellerInfo])

    return (
        shouldAppear && <OnlineIcon  data-test-component={dataTestLabel}  />
    )
}
